import { Component, inject, Inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BusinessReserveCompareChooseDialogModel } from '../../../interfaces/dialogs/business-reserve-compare-choose-dialog.model';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { PackageDetail } from '../../../interfaces/reserve-loading.model';
import { MatButton } from '@angular/material/button';
import { NumberCommaPipe } from '../../../../pipes/number-comma.pipe';

/**
 * 選擇比較企業方案dialog
 */
@Component({
  selector: 'app-business-reserve-compare-choose-dialog',
  standalone: true,
  imports: [TranslatePipe, MatButton, NumberCommaPipe],
  templateUrl: './business-reserve-compare-choose-dialog.component.html',
  styleUrl: './business-reserve-compare-choose-dialog.component.scss',
})
export class BusinessReserveCompareChooseDialogComponent implements OnInit {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);

  packageDetails: Array<PackageDetail> = []; // 企業方案列表

  constructor(
    public dialogRef: MatDialogRef<BusinessReserveCompareChooseDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: BusinessReserveCompareChooseDialogModel
  ) {}

  ngOnInit(): void {
    const businessPlanResponse = this.sharedStorageService.get(
      'businessPlanResponse'
    );
    if (businessPlanResponse) {
      // 過濾已經存在的方案
      const secondComparedPackage = this.sharedStorageService.get(
        'secondComparedPackage'
      );
      const thirdComparedPackage = this.sharedStorageService.get(
        'thirdComparedPackage'
      );
      const excludedPackageNos = new Set(this.data.excludedPackageNo);
      if (secondComparedPackage?.packageNo) {
        excludedPackageNos.add(secondComparedPackage.packageNo);
      }
      if (thirdComparedPackage?.packageNo) {
        excludedPackageNos.add(thirdComparedPackage.packageNo);
      }
      this.packageDetails = businessPlanResponse.packageList.filter(
        (packageDetail: PackageDetail) =>
          !this.data.excludedPackageNo.has(packageDetail.packageNo)
      );
    }
  }

  // 選擇比較方案
  selectPackage(packageDetail: PackageDetail): void {
    this.data.selectPackageAction(packageDetail);
    this.closeDialog();
  }

  // 關閉dialog
  closeDialog(): void {
    this.dialogRef.close();
  }
}
